import { render, staticRenderFns } from "./SubsetAddOrEdit.vue?vue&type=template&id=193b97fa&scoped=true"
import script from "./SubsetAddOrEdit.vue?vue&type=script&lang=js"
export * from "./SubsetAddOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193b97fa",
  null
  
)

export default component.exports